export default "__VITE_ASSET__C2jlh0Gy__"